import _ from 'lodash';
import dayjs from 'dayjs';
import axios from 'axios';
import moment from 'moment';
import { connect } from 'react-redux';
import { StyledBox, StyledBoxHeader } from '../../../CSS/style';
import Highlighter from 'react-highlight-words';
import { decode as base64_decode } from 'base-64';
import { constant } from '../../../Utils/constants';
import TableSelect from '../../../Widgets/TableSelect';
import { API_DEVICE } from '../../../../../commons/api';
import React, { useEffect, useRef, useState } from 'react';
import localStorage from '../../../../../utils/localStorage';
import InputComponent from '../../../Widgets/InputComponent';
import translation from '../../../../../commons/translation';
import { DownOutlined, SearchOutlined } from '@ant-design/icons';

import { Form, message, Select, DatePicker, Input, Modal, Button } from 'antd';
import {
  getDeviceList,
  getSitesList,
  getWorkTypes,
  getSRByID,
  getUsersList,
  getStatus,
  getLocationByAsset,
  // getServiceReqId,
  submitSR
} from '../../../Utils/FormCalls';
import { StyledHomepageSides } from '../../../../../commons/styles/layout';

const { TextArea } = Input;

const ServiceRequestForm = (props) => {
  const [deviceList, setDeviceList] = useState([]);
  const [sitesList, setSitesList] = useState([]); // Initialize as an empty array
  const [statusList, setStatusList] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [workTypesList, setWorkTypesList] = useState([]);
  const [formObject, setFormObject] = useState(props.formObject || {});
  const [visible, setVisible] = useState(false);
  const [viewCM, setViewCM] = useState(false);
  const [viewInspection, setViewInspection] = useState(false);
  const [workorderdisabled, setWorkOrderDisabled] = useState(true);
  const [searchText, setSearchText] = useState('');
  const [tableData, setTableData] = useState([]);
  const formHeader = useRef(null);
  const searchInput = useRef(null);


  useEffect(() => {
    const fetchData = async () => {
      try {
        await _getDataById();
        const sites = await getSitesList();
        setSitesList(sites); // Set the sites list

        // const initialFormObject = {
        // ...formObject,
        // WorkType: !formObject.id ? 11 : formObject.WorkType,
        // SiteId: sites.length > 0 ? sites[0]?.Id : '' // Ensure sites has data
        // };
        // setFormObject(initialFormObject);
        // if (formHeader.current) {
        // formHeader.current.setFieldsValue(initialFormObject);
        // }

        const devices = await getDeviceList();
        setDeviceList(devices);

        const users = await getUsersList();
        setUsersList(users);

        const workTypes = await getWorkTypes();
        setWorkTypesList(workTypes);

        const statuses = await getStatus();
        setStatusList(statuses);
        // const WAPPRStatus = statuses.filter(status => status.Status === 'WAPPR');
        // const WOStatusId = WAPPRStatus[0]?.Id;
        if (!formObject.Id) {
          // const workOrderName = await getServiceReqId();
          // handleChange(workOrderName['SR'], 'SRId');
          // handleChange(WOStatusId, 'WOStatusId');
        }
      } catch (error) {
        message.warning(`${error.message}`);
      }
    };

    fetchData();
  }, []);

  const handleChange = async (value, key) => {
    let updatedFormObject = formHeader.current ? formHeader.current.getFieldsValue() : {};

    if (key === 'Device') {
      const selectedDevice = deviceList.find(item => item.AliasCode === value);
      const location = await getLocationByAsset(selectedDevice?.Asset);

      updatedFormObject = {
        ...updatedFormObject,
        [key]: value,
        EquipmentDescription: selectedDevice?.AliasCode,
        Location: location.AssetCode,
        LocationDescription: location.Name
      };
    } else if (key === 'CreatedBy') {
      const selectedUser = usersList.find(item => item.Id === value);
      updatedFormObject = {
        ...updatedFormObject,
        [key]: value,
        Name: selectedUser?.UserName,
        Phone: selectedUser?.MobileNumber,
        Email: selectedUser?.Email
      };
    } else if (['TargetStart', 'TargetFinish', 'ActualStart', 'ActualFinish'].includes(key)) {
      updatedFormObject = {
        ...updatedFormObject,
        [key]: dayjs(value).format('YYYY-MM-DD')
      };
    } else if (key === 'WorkType') {
      if (value === 8) {
        setViewCM(true);
        setViewInspection(false);
      } else if (value === 9) {
        setViewInspection(true);
        setViewCM(false);
      }
      updatedFormObject = {
        ...updatedFormObject,
        [key]: value
      };
    } else {
      updatedFormObject = {
        ...updatedFormObject,
        [key]: value
      };
    }

    if (formHeader.current) {
      formHeader.current.setFieldsValue(updatedFormObject);
    }
    setFormObject(updatedFormObject);
  };

  const _getDataById = async (SRId) => {
    let formObject = {};
    const path = props.location.pathname.split('/rubus/AMM/SRDetails/');
    const formId = SRId || base64_decode(path[1]);
    if (formId !== 'new') {
      const data = await getSRByID(formId);
      if (data?.WorkType === 8) {
        setViewCM(true);
      } else if (data?.WorkType === 9) {
        setViewInspection(true);
      } else {
        setViewCM(false);
        setViewInspection(false);
      }
      formObject = data || {};
      _.cloneDeepWith(data, (value) => {
        return value && value !== null
          ? {
            ...value,
            ...(value['CreatedTime'] = moment.utc(value.CreatedTime, 'YYYY-MM-DD HH:mm:ss').local()),
            ...(value['TargetStart'] = value.TargetStart ? dayjs.utc(value.TargetStart, 'YYYY-MM-DD') : null),
            ...(value['TargetFinish'] = value.TargetFinish ? dayjs.utc(value.TargetFinish, 'YYYY-MM-DD') : null)
          }
          : _.noop();
      });
      try {
        formObject = {
          ...formObject,
          // SiteId: localStorage.get('currentSite') ? parseInt(localStorage.get('currentSite')) : ''
        };
        if (formHeader.current) {
          formHeader.current.setFieldsValue(formObject);
        }
        setFormObject(formObject);
      } catch (error) {
        message.warning(`${error.message}`);
      }
      try {
        const statuses = await getStatus();
        setStatusList(statuses);
        if (!formObject.Id) {
          const WAPPRStatus = statuses.filter(status => status.Status === 'WAPPR');
          const WOStatusId = WAPPRStatus[0]?.Id;
          handleChange(formObject['SR'], 'SRId');
          handleChange(WOStatusId, 'WOStatusId');
        }
      } catch (error) {
        message.warning(`${error.message}`);
      }
    }
  };

  const onFinish = async (values) => {
    const payload = {
      ...formObject,
      ...values
    };
    const statusResponse = await submitSR(payload);

    if (statusResponse?.message) {
      _getDataById(statusResponse.message);
      message.success(formObject.Id ? 'Service Request updated successfully' : 'Service Request submitted successfully');
      if (!formObject.Id) {
        props.navigate('/rubus/AMM/SRList');
      }
      enableWorkOrder();
    } else if (statusResponse?.Error) {
      message.error(statusResponse.Error);
    }
  };

  const enableWorkOrder = () => {
    setWorkOrderDisabled(false);
  };

  const createWorkOrder = async () => {
    message.warning('Development in progress');
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation(props.translationCache, `Search`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}

          style={{ width: 90, marginRight: 8 }}
        >
          {translation(props.translationCache, `Search`)}
        </Button>
        <Button
          danger
          onClick={() => handleReset(clearFilters)}

          style={{ width: 90 }}
        >
          {translation(props.translationCache, `Reset`)}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text?.toString()}
      />
    )
  });

  const TableDropdownChange = async (value) => {
    const selectedDevice = deviceList.find(item => item.AliasCode === value.AliasCode);
    await getLocationByAsset(selectedDevice?.Asset);
    const updatedFormObject = {
      ...formHeader.current.getFieldsValue(),
      Device: value.AliasCode,
      DisplayCode: value.DisplayCode,
      DeviceCode: value.DeviceCode,
      EquipmentDescription: value.Name,
      AssetDisplayCode: value.AssetDisplayCode,
      Location: value.Location,
      // AssetDisplayCode:value.AssetDisplayCode,
      LocationDescription: value.LocationDescription
    };
    if (formHeader.current) {
      formHeader.current.setFieldsValue(updatedFormObject);
    }
    setFormObject(updatedFormObject);
    setVisible(false);
  };

  const getDeviceData = async () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');


    try {
      const { data } = await axios.get(`${API_DEVICE.LIST}?SiteId=${siteId}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      setTableData(data);
      if (formHeader.current) {
        setFormObject(formHeader.current.getFieldsValue());
      }
      setVisible(true);
    } catch (error) {
      console.error('Error fetching device data:', error);
    }
  };

  const onModalCancel = (e) => {
    if (e.target.tagName === 'DIV') {
      e.preventDefault();
      message.error('Please Click On Cancel');
    } else {
      setVisible(false);
    }
  };

  const onModalOk = () => {
    setVisible(false);
  };

  return (
    <StyledHomepageSides>
      <Form
        name="SR"
        ref={formHeader}
        onFinish={onFinish}
        initialValues={formObject}
        layout="vertical"
      >
        <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
          <Button
            type="primary"
            style={{ marginLeft: '5px' }}
            htmlType="submit"
          >
            {translation(props.translationCache, constant.submit)}
          </Button>
          <Button
            disabled={workorderdisabled}
            htmlType="submit"
            onClick={createWorkOrder}
          >
            {translation(props.translationCache, constant.createWorkOrder)}
          </Button>
        </div>
        <StyledBoxHeader>
          <StyledBox>
            <Form.Item
              label={translation(props.translationCache, constant.serviceRequestID)}
              name="SRId"
              rules={[{ required: true, message: 'Please Input JobPlan!' }]}
            >
              <InputComponent
                style={{ width: '100%' }}
                placeholder={translation(props.translationCache, 'ID')}
                disabled={formObject && formObject.Id ? true : false}
                value={formObject.JobPlanName}
                onChange={(value) => handleChange(value, 'SRId')}
              />
            </Form.Item>
            <Form.Item
              label={translation(props.translationCache, constant.description)}
              name="Description"
              rules={[
                { required: true, message: translation(props.translationCache, 'Input Description!') }
              ]}
            >
              <InputComponent
                style={{ width: '100%' }}
                placeholder={translation(props.translationCache, 'Input Description')}
                onChange={(value) => handleChange(value, 'Description')}
              />
            </Form.Item>

            <Form.Item

              label={translation(props.translationCache, constant.equipment)}
              name="DisplayCode"
              rules={[
                { required: true, message: translation(props.translationCache, 'Select Equipment') }
              ]}
            >
              <Input
                style={{
                  width: '100%'
                }}
                placeholder={translation(props.translationCache, 'Select Equipment')}
                disabled={true}
                suffix={
                  <DownOutlined
                    style={{
                      color: formObject?.Id ? null : '#1a3b5c',
                      cursor: formObject?.Id ? 'not-allowed' : null,
                      opacity: formObject?.Id ? '0.8' : null
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      if (formObject && !formObject.Id) {
                        getDeviceData('visible');
                      }
                    }}
                  />
                }
              />
            </Form.Item>
            <Form.Item
              style={{
                width: '100%',
                flex: '50%'
              }}
              label={translation(props.translationCache, constant.equipmentDescription)}
              name="EquipmentDescription"
              rules={[
                {
                  required: true,
                  message: translation(
                    props.translationCache,
                    'Autopopulate based on equipment selection'
                  )
                }
              ]}
            >
              <InputComponent
                style={{ width: '100%' }}
                disabled
                placeholder={translation(
                  props.translationCache,
                  'Autopopulate based on equipment selection'
                )}
              />
            </Form.Item>
            <Form.Item

              label={translation(props.translationCache, constant.Location)}
              name="AssetDisplayCode"
              rules={[
                {
                  required: true,
                  message: translation(
                    props.translationCache,
                    'Autopopulate based on equipment selection'
                  )
                }
              ]}
            >
              <InputComponent
                style={{ width: '100%' }}
                placeholder={translation(
                  props.translationCache,
                  'Autopopulate based on equipment selection'
                )}
                disabled={true}
              />
            </Form.Item>
            <Form.Item
              style={{
                width: '100%',
                flex: '50%'
              }}
              label={translation(props.translationCache, constant.locationDescription)}
              name="LocationDescription"
              rules={[
                {
                  required: true,
                  message: translation(
                    props.translationCache,
                    'Autopopulate based on equipment selection'
                  )
                }
              ]}
            >
              <InputComponent
                style={{ width: '100%' }}
                placeholder={translation(
                  props.translationCache,
                  'Autopopulate based on equipment selection'
                )}
                disabled={true}
              />
            </Form.Item>

            <Form.Item

              label={translation(props.translationCache, constant.status)}
              name="WOStatusId"
              rules={[{ required: false, message: 'Please Select Status' }]}
            >
              <Select
                disabled={formObject && formObject.Id ? true : false}
                placeholder={translation(props.translationCache, 'Select Status')}
                onChange={(value) => handleChange(value, 'WOStatusId')}
                style={{ width: '100%' }}
              >
                {statusList.map((status, index) => (
                  <Select.Option key={index} value={status.Id}>
                    {translation(props.translationCache, status.StatusDescription)}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              style={{
                width: '100%',
                flex: '50%'
              }}
              label={translation(props.translationCache, constant.site)}
              name="SiteId"
              rules={[{ required: true, message: 'Please Select Site' }]}
            >
              <Select
                placeholder={translation(props.translationCache, 'Select Site')}
                onChange={(value) => handleChange(value, 'SiteId')}
                style={{ width: '100%' }}
              >
                {sitesList.length > 0 ? (
                  sitesList.map((site, index) => (
                    <Select.Option key={index} value={site.Id}>
                      {site.Name}
                    </Select.Option>
                  ))
                ) : (
                  <Select.Option disabled>No sites available</Select.Option>
                )}
              </Select>
            </Form.Item>

            <Form.Item

              label={translation(props.translationCache, constant.createdBy)}
              name="CreatedBy"
              rules={[{ required: false, message: 'Select Created By' }]}
            >
              <Select
                style={{ width: '100%' }}
                disabled={true}
                placeholder={translation(props.translationCache, 'Created By')}
                onChange={(value) => handleChange(value, 'CreatedBy')}
              >
                {usersList.map((user, index) => (
                  <Select.Option key={index} value={user.Id}>
                    {user.FirstName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item

              label={translation(props.translationCache, constant.CreatedDate)}
              name="CreatedTime"
              rules={[{ required: false, message: 'Created Date' }]}
            >
              <DatePicker
                format="YYYY-MM-DD HH:mm:ss"
                style={{ width: '100%' }}
                disabled={true}
                placeholder={translation(props.translationCache, 'Created Date')}
              />
            </Form.Item>
            <Form.Item

              label={translation(props.translationCache, 'Target Start')}
              name="TargetStart"
              rules={[{ required: false, message: 'Please Input TargetStart!' }]}
            >
              <DatePicker
                style={{ width: '100%' }}
                placeholder={translation(props.translationCache, 'Select Date')}
                format="YYYY-MM-DD"
                disabledDate={(d) =>
                  !d ||
                  d.isAfter(
                    formHeader.current?.getFieldValue('TargetFinish')
                      ? dayjs(formHeader.current.getFieldValue('TargetFinish'))
                      : ''
                  )
                }
              />
            </Form.Item>

            <Form.Item

              label={translation(props.translationCache, 'Target Finish')}
              name="TargetFinish"
              rules={[{ required: false, message: 'Please Input Target Finish!' }]}
            >
              <DatePicker
                style={{ width: '100%' }}
                placeholder={translation(props.translationCache, 'Please Select Date')}
                format="YYYY-MM-DD"
                disabledDate={(d) =>
                  !d ||
                  d.isBefore(
                    formHeader.current?.getFieldValue('TargetStart')
                      ? dayjs(formHeader.current.getFieldValue('TargetStart'))
                      : ''
                  )
                }
              />
            </Form.Item>

            <Form.Item

              label={translation(props.translationCache, constant.summary)}
              name="Summary"
              rules={[{ required: false, message: 'Please Input Field!' }]}
            >
              <TextArea
                rows={3}
                style={{ width: '100%' }}
                placeholder={translation(props.translationCache, 'Input Summary')}
              />
            </Form.Item>

            <Form.Item name="Device"></Form.Item>

          </StyledBox>
        </StyledBoxHeader>

        <StyledBoxHeader>
          <StyledBox>
            <Form.Item
              label={translation(props.translationCache, constant.workType)}
              name="WorkType"

              rules={[{ required: false }]}
            >
              <Select
                placeholder={translation(props.translationCache, 'Select Work Type')}
                onChange={(value) => handleChange(value, 'WorkType')}
                style={{ width: '100%' }}
              >
                {workTypesList.map((workType, index) => (
                  <Select.Option
                    key={index}
                    value={workType.Id}
                    disabled={
                      formObject &&
                        !formObject.id &&
                        workType.Id === 11 &&
                        workType.WorkType === 'Common Work'
                        ? false
                        : true
                    }
                  >
                    {translation(props.translationCache, workType.WorkType)}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            {viewCM && (
              <Form.Item
                label={translation(props.translationCache, constant.conditionPoint)}
                name="ConditionPoint"

                rules={[{ required: false }]}
              >
                <InputComponent
                  style={{ width: '100%' }}
                  disabled={true}
                  placeholder={translation(props.translationCache, 'Input conditionPoint')}
                />
              </Form.Item>
            )}

            {viewInspection && (
              <Form.Item

                label={translation(props.translationCache, constant.inspectionArea)}
                name="InspectionArea"
              >
                <InputComponent
                  style={{ width: '100%' }}
                  placeholder={translation(
                    props.translationCache,
                    'Autopopulate based on Inspection'
                  )}
                  disabled={true}
                />
              </Form.Item>
            )}
          </StyledBox>
        </StyledBoxHeader>
        <Modal
          open={visible}
          width={800}
          closable
          title={translation(props.translationCache, constant.selectEquipment)}
          onOk={onModalOk}
          onCancel={onModalCancel}
        >
          <TableSelect
            data={tableData}
            translationCache={props.translationCache}
            key="Location"
            columns={[
              {
                title: translation(props.translationCache, 'Equipment'),
                dataIndex: 'DisplayCode',
                key: 'DisplayCode',
                ...getColumnSearchProps('DisplayCode')
              },
              {
                title: translation(props.translationCache, 'Equipment Description'),
                dataIndex: 'Name',
                key: 'Name',
                ...getColumnSearchProps('Name')
              }
            ]}
            handleDropdownChange={(e) => TableDropdownChange(e, 'visible')}
          />
        </Modal>
      </Form>
    </StyledHomepageSides>
  );
};

const mapStateToProps = (state) => {
  return {
    themeValue: state.ThemeReducer,
    translationCache: state.TranslationReducer.translationCache,
  };
};

export default connect(mapStateToProps)(ServiceRequestForm);